import { useEffect, useState } from 'react'
import styles from './CustomerSelect.module.scss'
import { IIntegrationPartner, IpNames } from '../../../interfaces/interfaces'
import AccountSelect from './AccountSelect/AccountSelect'
import { BsArrowLeft } from 'react-icons/bs'

type Props = {
    customers: any,
    ip: IIntegrationPartner,
    selectedCustomers: any,
    setSelectedCustomers: Function,
    allConnectedAccounts: any
}

const ignoreIdForRpaIp = new Set([IpNames.swiggyInstamart]);

const CustomerSelect = ({ customers, ip, selectedCustomers, setSelectedCustomers, allConnectedAccounts }: Props) => {
    const [step, setStep] = useState(1)
    const [parent, setParent] = useState('Account')
    const [child, setChild] = useState('')
    const [hasChild, setHasChild] = useState(false)
    const [selectedParent, setSelectedParent] = useState<any>({})
    const [connectedClients, setConnectedClients] = useState([])

    console.log('selectedCustomers', selectedCustomers)

    useEffect(() => {
        setConnectedClients(() => {
            const temp = allConnectedAccounts.map(acc => {
                return acc.store_name ? acc.store_name : acc.client_id ? acc.client_id : acc.customer_id;
            })
            return temp
        })
    }, [allConnectedAccounts])

    useEffect(() => {
        if (customers?.length) {
            setParent(customers[0]?.parentName)
            setChild(customers[0]?.childName)
            setHasChild(customers[0]?.hasChild)
        }
    }, [customers])

    const handleCustomersSelect = (customer) => {
        setSelectedCustomers(prev => {
            if (prev[customer?.id]?.selected) {
                return {
                    ...prev,
                    [customer?.id]: {
                        selected: false
                    }
                }
            } else {
                return {
                    ...prev,
                    [customer?.id]: {
                        selected: true,
                        details: customer
                    }
                }
            }
        })
    }

    const handleParentClick = (parent) => {
        if (hasChild) {
            setSelectedParent(parent)
            setStep(2)
        } else {
            handleCustomersSelect(parent)
        }
    }

    const handleChildClick = (child) => {
        handleCustomersSelect(child)
    }

    const showConnectedTag = (id) => {
        if (!hasChild) return false;
        let connectedCount = 0
        for (var i of allConnectedAccounts) {
            if (i.customer_id == id) {
                connectedCount++
            }
        }
        let clientCount = 0
        for (var i of customers) {
            if (i?.id == id) {
                clientCount = i?.childs?.length
            }
        }
        if (connectedCount == clientCount) {
            return true
        }
        return false
    }

    // const getHardSelect = (id) => {
    //     allConnectedAccounts.forEach((acc) => {
    //         if(acc.client_id == id) {
    //             return true
    //         }
    //     })
    //     return false
    // } 

    // const isIgnoreId = ignoreIdForRpaIp.has(ip.companyName as IpNames);


    return (
        <>
            <div className={styles.header}>
                <img src={ip.logo} />
                <h2>{ip.companyName}</h2>
            </div>
            <p className={styles.select}>
                Select your <span>Account</span>
            </p>
            <div className={styles.accounts}>
                {
                    !customers?.length ?
                        <div className={styles.noAccounts}>
                            <p>No valid {ip.companyName} account found for this email.</p>
                        </div>
                        : null
                }
                {
                    step == 1 ?
                        <>
                            {
                                customers.map(cust => {
                                    if (cust?.id || cust?.name)
                                        return (
                                            <AccountSelect
                                                //  isIgnoreId={isIgnoreId} 
                                                parent={cust} hasChild={hasChild} handleClick={(parent) => handleParentClick(parent)} selectedCustomers={selectedCustomers} hardSelect={connectedClients.includes(cust?.id)} showConnectedTag={showConnectedTag(cust?.id)} />
                                        )
                                })
                            }
                        </> : null
                }
                {
                    step == 2 ?
                        <>
                            <div className={styles.childHeader} onClick={() => { setStep(1) }}>
                                <BsArrowLeft />
                                <p>{selectedParent?.name ? selectedParent?.name : selectedParent?.id}</p>
                            </div>
                            {
                                selectedParent?.childs?.map(child => {
                                    if (child?.id || child?.name)
                                        return (
                                            <AccountSelect parent={child} hasChild={false} handleClick={(child) => handleChildClick(child)} selectedCustomers={selectedCustomers} hardSelect={connectedClients.includes(child?.id)} showConnectedTag={false} />
                                        )
                                })
                            }
                        </> : null
                }
            </div>
        </>
    )
}

export default CustomerSelect